/** @format */
import { Heading } from '@mpb-com/feather/components/atoms/heading';
import {
    HeadingAlignment,
    HeadingSize,
} from '@mpb-com/feather/components/atoms/heading/types';
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent } from 'react';

export const OAuthErrorModal: FunctionComponent = () => {
    const { t } = useTranslation();

    return (
        <Heading
            data-testid="oauth-error-modal"
            size={HeadingSize.H2}
            alignment={HeadingAlignment.CENTER}
        >
            {t('Uh Oh! Something went wrong!')}
        </Heading>
    );
};
